








































		import { Component, Vuex, Vue} from "../../../Infrastructure/CorBase/CoreBase";
		import NationalHolidayListBase from "./NationalHolidayListBase";

		Vue.use(Vuex);
		const store = new Vuex.Store({
			state: {
				selectedState: ''
			}
		})

		@Component
		export default class NationalHolidayList extends NationalHolidayListBase {

			showAllertToDeleteClick(itemsSelected: any) {
				//this.showAllertToDeleteClickBase(itemsSelected);
                this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
                if (this.$store.state.askBeforeDelete) {

                    super.showAlertBeforeActionClickBase(itemsSelected, super.prepareRemoveMessage(), true);
                }
                else {
                    this.itemsSelected = itemsSelected;
                    this.callActionClick();
                }
			}

			selectRows(items: any) {
				super.selectRows(items);
			}
					

			created() {	
				super.initializeRights('COR_NationalHoliday_Create','COR_NationalHoliday_Delete', 'COR_NationalHoliday_Read', 'COR_NationalHoliday_Update');			
			
				super.created();
				super.setDetailName('NationalHolidayDetail');
				this.selectedState = store.state.selectedState;
				this.prepareCountryEnum();
                this.setDeleteMessage(this.$t('nationalHoliday.messageQuestionMain').toString(), this.$t('nationalHoliday.messageQuestionMain2').toString(), this.$t('nationalHoliday.messageQuestionMain3').toString());

			};
					

			// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
			loadFilters(value: any) { super.loadFilters(value); };
			createNewClick(elementId: any) {	super.createNewClick(elementId); }
			detailClick(elementId: any) { super.detailClick(elementId); };
			deleteClick(elementId: any) { super.deleteClick(elementId); }



		};
	